import React, { useId } from "react";
import { Button, Form, InputNumber } from "antd";
import { isBookedWorkersValid } from "../helpers/booking-policy";
import BookingCompanySelect from "./fields/booking-company-select";


const BookingForm = ({ booking, rows, saving, disabled, onSave, onCancel, text, registeredScopeHint }) => {
    const [ form ] = Form.useForm();
    const registeredScopeHintID = useId();
    return (
        <Form form={ form } layout="vertical" initialValues={ {
            subcontractor_id: booking?.subcontractor_id,
            booked_workers: booking?.booked_workers ?? 0,
        } } onFinish={ onSave }>
            { booking ? <Form.Item label={ text("Company") }>
                <strong>{ booking.relSubcontractor?.title || text("Unavailable") }</strong>
            </Form.Item> : <Form.Item name="subcontractor_id" label={ text("Company") }
                rules={ [ { required: true, message: text("ChooseCompany") } ] }>
                <BookingCompanySelect disabled={ disabled } excludedIds={ rows.map(row => row.subcontractor_id) } text={ text } />
            </Form.Item> }
            <Form.Item name="booked_workers" label={ text("Booked") }
                extra={ <span id={ registeredScopeHintID } className="booked-subcontractors__hint">{ registeredScopeHint }</span> } rules={ [ {
                validator: (_, value) => isBookedWorkersValid(value)
                    ? Promise.resolve() : Promise.reject(new Error(text("InvalidQuantity"))),
            } ] }>
                <InputNumber disabled={ disabled } step={ 1 }
                    aria-label={ text("Booked") } aria-describedby={ registeredScopeHintID } style={ { width: "100%" } } />
            </Form.Item>
            <p className="booked-subcontractors__hint">{ text("QuantityHint") }</p>
            <div className="form-btn-holder">
                <Button className="ant-btn-secondary bg-light-gray" disabled={ saving } onClick={ onCancel }>{ text("Cancel") }</Button>
                <Button className="btn-right" type="primary" htmlType="submit" disabled={ disabled } loading={ saving }>{ text("Save") }</Button>
            </div>
        </Form>
    );
};

export default BookingForm;
